<template>
  <div style="" class="father">
    <div class="right">
      <el-scrollbar
        wrapStyle="overflow-x:hidden;"
        style="width: 100%;height: 500px;background-color: #fff;"
      >
        <div class="father">
          <el-form
            label-width="300px"
            style="background-color: #fff; padding:0 20px 0 20px;width: 100%"
            ref="dataFormRef"
            :model="wxMchInfo"
            :rules="rules"
            label-position="top"
          >
            <div class="title">
              配置店铺微信支付
            </div>

            <div v-for="(item, index) in formList" :key="index">
              <el-form-item :label="item.label" :prop="item.value">
                <el-input
                  clearable
                  :show-password="item.value == 'pass_word'"
                  :blur="
                    item.value == 'sub_name'
                      ? subNameBlur(true)
                      : subNameBlur(false)
                  "
                  v-model="wxMchInfo[item.value]"
                  :placeholder="`请输入${item.label}`"
                >
                </el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </el-scrollbar>

      <div class="wty-footer">
        <el-button type="primary" @click="saveMerchantChange"> 保存 </el-button>
      </div>
    </div>
  </div>
</template>
<script>
let pinyin = require("js-pinyin");
import {payConfigurePay,payGetConfigure} from "@/api/v2/merchant.js";
export default {
  name: "wxPayInfo",
  data() {
    return {
      formList: [],
      mch_id: localStorage.getItem("mch_id"),
      wxMchInfo: {
        wx_mch_no:"",//微信店铺号
      },
      rules: this.getRules()
    };
  },
  mounted(){
    payGetConfigure().then(res=>{
      if(this.testR(res)){
        this.wxMchInfo.wx_mch_no = res.data.resp_data.wx_mch_no;
      }
    })
  },
  methods: {
    saveMerchantChange() {
      payConfigurePay(this.wxMchInfo).then(res => {
        
        if (res.data.return_code=="SUCCESS"&&res.data.result_code=="SUCCESS") {
          this.successMessage("修改成功");
        } 
      });
    },
    subNameBlur(key) {
      /* if (key) {
        this.wxMchInfo.pym = pinyin.getCamelChars(this.wxMchInfo.sub_name);
      } */
    },
    getRules() {
      let list = [
        { label: "微信店铺号：", value: "wx_mch_no", type: "false" }
      ];
      var rules = {};
      // var wtycolumnList = [];
      for (let i = 0; i < list.length; i++) {
        if (list[i].type == "false") {
          rules[list[i].value] = [
            {
              required: true,
              message: `请输入${list[i].label}`,
              trigger: "blur"
            }
          ];
        }
      }
      this.$nextTick(() => {
        this.formList = list;
      });
      return rules;
    }
  }
};
</script>
<style scoped lang="less">
.title {
  border-bottom: 2px solid rgb(0, 89, 184);
  color: rgb(0, 89, 184);
  margin-bottom: 10px;
  font-size: 24px;
  font-weight: 700;
}
.el-breadcrumb {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;
  padding-left: 20px;
  padding-top: 5px;
  margin-bottom: 0;
  font-size: 16px;
  z-index: 99;
}
.father {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #fff;
  display: flex;
  justify-content: center;
  padding: 10px;
}
.fa-morf {
  margin-top: 20px;
}

.right {
  width: 50%;
  min-width: 600px;
  float: left;
}
.el-input {
  width: 400px;
}
.wty-footer {
  height: 50px;
  .el-button {
    width: 200px;
  }
}
</style>
